<template>
  <div class="dialog-layer">
    <fruit-order v-if="!isStudent" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import FruitOrder from "../fruit-order/Index.vue";

export default {
  name: "DialogLayer",
  components: {
    FruitOrder,
  },
  mounted() {
    console.log("DialogLayer mounted");
  },
  computed: {
    ...mapState("live", ["imService", "roomInfo"]),
    isStudent() {
      return this.roomInfo.isStudent;
    },
    isTeacher() {
      return this.roomInfo.isTeacher;
    },
    isAssistant() {
      return this.roomInfo.isAssistant;
    },
  },
};
</script>

<style></style>
